export default  {
    knobX: 88,
    knobY: 88,
    svg:`
    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="184px" height="184px" viewBox="0 0 184 184" version="1.1">
    <!-- Generator: Sketch 47.1 (45422) - http://www.bohemiancoding.com/sketch -->
    <desc>Created with Sketch.</desc>
    <defs>
        <radialGradient cx="50%" cy="50%" fx="50%" fy="50%" r="50%" gradientTransform="translate(0.500000,0.500000),rotate(90.000000),scale(1.000000,0.979317),translate(-0.500000,-0.500000)" id="ec243611-2c9d-3ec4-4f62-462a5e0c7d18">
            <stop stop-color="#6B6767" offset="0%"/>
            <stop stop-color="#514F4F" offset="100%"/>
        </radialGradient>
        <path d="M174.99856,101.33904 C175.6568,96.98832 176,92.532 176,87.99824 C176,83.46448 175.6568,79.01168 174.99856,74.66096 L152.79792,63.76304 C152.23472,62.25824 151.62224,60.77632 150.9552,59.32432 L158.94384,35.92864 C153.648,28.71968 147.28032,22.352 140.07488,17.05616 L116.67744,25.0448 C115.22544,24.38128 113.74528,23.76704 112.23872,23.20384 L101.3408,1.00496 C96.99008,0.34144 92.53376,0 88,0 C83.46624,0 79.01168,0.34144 74.66096,1.00496 L63.76304,23.20384 C62.25824,23.76704 60.77808,24.38128 59.32432,25.0448 L35.92688,17.05616 C28.72144,22.352 22.35376,28.72144 17.05616,35.92688 L25.04304,59.32256 C24.38128,60.77456 23.7688,62.25648 23.20384,63.76128 L1.00496,74.66096 C0.3432,79.01168 0,83.46448 0,87.99824 C0,92.532 0.3432,96.98832 1.00496,101.33904 L23.20384,112.23696 C23.7688,113.74176 24.38128,115.22192 25.04304,116.67744 L17.05616,140.07312 C22.35376,147.27856 28.72144,153.64624 35.92688,158.9456 L59.32256,150.95872 C60.77632,151.62048 62.25648,152.23296 63.76128,152.79616 L74.6592,174.9968 C79.01168,175.6568 83.46624,176 88,176 C92.53376,176 96.99008,175.6568 101.3408,174.9968 L112.23696,152.79616 C113.74352,152.23296 115.22368,151.62048 116.6792,150.95872 L140.07312,158.9456 C147.27856,153.64624 153.64624,147.27856 158.94208,140.07312 L150.9552,116.6792 C151.62224,115.22368 152.23472,113.74352 152.79792,112.23872 L174.99856,101.33904 Z" id="7e94f06a-110e-e59a-f113-39669b52f739"/>
        <filter x="-3.7%" y="-3.7%" width="107.4%" height="107.4%" filterUnits="objectBoundingBox" id="a02fddba-09a4-ff6b-9524-35153ff65d2a">
            <feMorphology radius="0.5" operator="dilate" in="SourceAlpha" result="shadowSpreadOuter1"/>
            <feOffset dx="0" dy="0" in="shadowSpreadOuter1" result="shadowOffsetOuter1"/>
            <feGaussianBlur stdDeviation="2" in="shadowOffsetOuter1" result="shadowBlurOuter1"/>
            <feComposite in="shadowBlurOuter1" in2="SourceAlpha" operator="out" result="shadowBlurOuter1"/>
            <feColorMatrix values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0" type="matrix" in="shadowBlurOuter1"/>
        </filter>
        <radialGradient cx="50%" cy="50%" fx="50%" fy="50%" r="50%" id="542e5438-927e-34cf-5b22-5a2967321d2d">
            <stop stop-color="#868282" stop-opacity="0.5" offset="0%"/>
            <stop stop-color="#5E5A5A" stop-opacity="0.985252491" offset="100%"/>
        </radialGradient>
        <path d="M87.9930302,142 C58.1714064,142 34,117.820341 34,87.9953536 C34,58.1750129 58.1714064,34 87.9930302,34 C117.814654,34 142,58.1750129 142,87.9953536 C142,117.820341 117.814654,142 87.9930302,142 Z" id="3bfd6036-f6a6-7bd7-b7ac-954ed18e8926"/>
        <filter x="-5.6%" y="-5.6%" width="111.1%" height="111.1%" filterUnits="objectBoundingBox" id="2bc0a6cf-17a1-c6d0-5c11-ed9fd35402d6">
            <feOffset dx="0" dy="0" in="SourceAlpha" result="shadowOffsetOuter1"/>
            <feGaussianBlur stdDeviation="2" in="shadowOffsetOuter1" result="shadowBlurOuter1"/>
            <feColorMatrix values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0" type="matrix" in="shadowBlurOuter1"/>
        </filter>
        <filter x="-5.6%" y="-5.6%" width="111.1%" height="111.1%" filterUnits="objectBoundingBox" id="ebf96221-9cdc-4b35-5182-04b8697d47d1">
            <feGaussianBlur stdDeviation="1.5" in="SourceAlpha" result="shadowBlurInner1"/>
            <feOffset dx="0" dy="1" in="shadowBlurInner1" result="shadowOffsetInner1"/>
            <feComposite in="shadowOffsetInner1" in2="SourceAlpha" operator="arithmetic" k2="-1" k3="1" result="shadowInnerInner1"/>
            <feColorMatrix values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0" type="matrix" in="shadowInnerInner1"/>
        </filter>
        <path d="M85,1.24236701 C86.8525183,1.080789 88.269185,1 89.25,1 C90.230815,1 91.6474817,1.080789 93.5,1.24236701 L93.5,34.242367 L85,34.242367 L85,1.24236701 Z" id="62d82186-ee01-d66b-3c1c-355ecc71e152"/>
        <filter x="-11.8%" y="-3.0%" width="123.5%" height="106.0%" filterUnits="objectBoundingBox" id="9fe9258a-0910-4f2c-3179-fdc69c881a7f">
            <feGaussianBlur stdDeviation="0.5" in="SourceAlpha" result="shadowBlurInner1"/>
            <feOffset dx="0" dy="1" in="shadowBlurInner1" result="shadowOffsetInner1"/>
            <feComposite in="shadowOffsetInner1" in2="SourceAlpha" operator="arithmetic" k2="-1" k3="1" result="shadowInnerInner1"/>
            <feColorMatrix values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0" type="matrix" in="shadowInnerInner1"/>
        </filter>
        
        <filter x="-6.7%" y="-14.3%" width="113.3%" height="128.6%" filterUnits="objectBoundingBox" id="e875d763-45c6-18a0-bd7f-a97bef1528a8">
            <feOffset dx="0" dy="0" in="SourceAlpha" result="shadowOffsetOuter1"/>
            <feGaussianBlur stdDeviation="2" in="shadowOffsetOuter1" result="shadowBlurOuter1"/>
            <feColorMatrix values="0 0 0 0 0.915577168   0 0 0 0 0.797591325   0 0 0 0 0.601479722  0 0 0 1 0" type="matrix" in="shadowBlurOuter1"/>
        </filter>
    </defs>
    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="s17" transform="translate(4.000000, 4.000000)">
            <g id="container">
                <g id="knob">
                    <g id="Shape" fill-rule="nonzero">
                        <use fill="black" fill-opacity="1" filter="url(#a02fddba-09a4-ff6b-9524-35153ff65d2a)" xlink:href="#7e94f06a-110e-e59a-f113-39669b52f739"/>
                        <use stroke="#726E6E" stroke-width="1" fill="url(#ec243611-2c9d-3ec4-4f62-462a5e0c7d18)" fill-rule="evenodd" xlink:href="#7e94f06a-110e-e59a-f113-39669b52f739"/>
                    </g>
                    <g id="Path">
                        <use fill="black" fill-opacity="1" filter="url(#2bc0a6cf-17a1-c6d0-5c11-ed9fd35402d6)" xlink:href="#3bfd6036-f6a6-7bd7-b7ac-954ed18e8926"/>
                        <use fill="url(#542e5438-927e-34cf-5b22-5a2967321d2d)" fill-rule="evenodd" xlink:href="#3bfd6036-f6a6-7bd7-b7ac-954ed18e8926"/>
                        <use fill="black" fill-opacity="1" filter="url(#ebf96221-9cdc-4b35-5182-04b8697d47d1)" xlink:href="#3bfd6036-f6a6-7bd7-b7ac-954ed18e8926"/>
                    </g>
                    <g id="Rectangle-3">
                        <use fill="#D8D8D8" fill-rule="evenodd" xlink:href="#62d82186-ee01-d66b-3c1c-355ecc71e152"/>
                        <use fill="black" fill-opacity="1" filter="url(#9fe9258a-0910-4f2c-3179-fdc69c881a7f)" xlink:href="#62d82186-ee01-d66b-3c1c-355ecc71e152"/>
                    </g>
                </g>
                <g id="label-copy" transform="translate(42.000000, 67.000000)" fill="#E6D7D7" fill-opacity="1">
                    <g id="labeltext">
                        <text id="a14a3cd3-b46f-6742-926d-0e19c2ef1f07" font-family="Helvetica" font-size="34" font-weight="normal" fill="#E6D7D7" class="text-10" filter="url(#e875d763-45c6-18a0-bd7f-a97bef1528a8)">
            <tspan x="2.45849609" y="33">10.10</tspan>
        </text>
                        <text id="63c5bc48-12c5-6cba-cab9-1887b376ed59" font-family="Helvetica" font-size="34" font-weight="normal" fill="#E6D7D7" class="text-10">
            <tspan x="2.45849609" y="33">10.10</tspan>
        </text>
                    </g>
                </g>
            </g>
        </g>
    </g>
</svg>
`,
updateAttributes: [
    {
      element: "#labeltext text tspan",
      content: (props, value) => {
        return value.toFixed(0);
      },
      attrs: [
        {
          name: "text-anchor",
          value: (props, value) => {
            return "middle";
          }
        },
        {
          name: "x",
          value: (props, value) => {
            return "47";
          }
        }
      ]
    }
  ]
}